import { Move } from "@/types";
import { CalculatorIcon, HomeIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface LinksProps {
  move: Move;
}

const Links: React.FC<LinksProps> = ({ move }) => {
  return (
    <div className="flex flex-row lg:flex-col items-start gap-2 text-sm">
      {move.identifier && (
        <div className="flex items-center gap-1">
          <HomeIcon className="w-3 h-3" />
          <Link
            to={`/hub/${move.identifier}`}
            className="text-sm font-medium hover:underline hover:underline-offset-4 hover:decoration-yellow-500"
            target="_blank"
          >
            Customer Portal
          </Link>
        </div>
      )}

      {move.estimate_agreement && (
        <div className="flex items-center gap-1">
          <CalculatorIcon className="w-3 h-3" />
          <Link
            to={`/estimate/${move.estimate_agreement.ref}`}
            className="text-sm font-medium hover:underline hover:underline-offset-4 hover:decoration-yellow-500"
            target="_blank"
          >
            Estimate
          </Link>
        </div>
      )}

      {move.bill_of_lading_agreement && (
        <div className="flex items-center gap-1">
          <CalculatorIcon className="w-3 h-3" />
          <Link
            to={`/bol/${move.bill_of_lading_agreement.ref}`}
            className="text-sm font-medium hover:underline hover:underline-offset-4 hover:decoration-yellow-500"
            target="_blank"
          >
            Bill of Lading
          </Link>
        </div>
      )}
    </div>
  );
};

export default Links;
